var radioBtnData = {
  name: 'radioButton',
  data: [{
    fontFamily: 'MicrosoftYaHei',
    fontSize: 12,
    fontColor: '#5a6677',
    radius: 2,
    btnHeight: 22,
    btnPadding: '0 8px',
    btnMarginRight: 16,
    btnBoxShadow: 'none',
    borderColor: '#d9d9d9',
    checkedFontColor: '#fff',
    checkedBorderColor: '#4f7de7',
    checkedBgColor: '#4f7de7',
    disabledFontColor: '#AAADBA',
    disabledBorderColor: '#E7EAED',
    disabledBgColor: ' #F8F8F8'
  }]
};
export default radioBtnData;